import Header from "components/Headers/Header.js";
import { get } from "utils/api";
import { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Spinner,
} from "reactstrap";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { FaDownload } from "react-icons/fa";

const Report = () => {
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state to show loader

  const listData = [
    {
      id: 1,
      name: "Tenant List",
      fileName: "tenant_list",
      url: "/api/user/get-list-by-admin/tenant",
    },
    // {
    //   id: 2,
    //   name: "Furniture Company List",
    //   fileName: "furniture_company_list",
    //   url: "/api/user/get-list-by-admin/furniture_company",
    // },
    {
      id: 3,
      name: "Cleaning Company List",
      fileName: "cleaning_company_list",
      url: "/api/user/get-list-by-admin/cleaning_company",
    },
    {
      id: 4,
      name: "Home Owner List",
      fileName: "home_owner_list",
      url: "/api/user/get-list-by-admin/home_owner",
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Show loader while fetching data
      try {
        const newData = [];
        const responsePromises = listData.map(async (item) => {
          if (!item?.url) return item;
          const res = await get(item.url);
          return {
            ...item,
            total: res.data.rows.length, // Add total count
            data: res.data.rows, // Store fetched data
          };
        });

        // Use Promise.all to fetch both the list data and the additional sales data concurrently
        const [fetchedData, salesDataRes] = await Promise.all([
          Promise.all(responsePromises), // Fetch list data
          get("/api/admin/get/dashData"), // Fetch additional sales data
        ]);

        const data = salesDataRes?.data;

        if (data) {
          const yearlyData = data.salesValueData.yearly;
          const dailyData = data.salesValueData.daily;
          const yearlyCount = data.salesValueData.yearlyCount;
          const totalCleaningPackage = data.salesValueData.cleaningData.reduce(
            (acc, item) => acc + item.totalFrequency,
            0
          );
          const totalFurniturePackage =
            data.salesValueData.furnitureData.reduce(
              (acc, item) => acc + item.totalQuantity,
              0
            );

          // Format total values with 2 decimals and a dollar sign
          const formatCurrency = (amount) => `$${amount.toFixed(2)}`;

          // Update listData state correctly by creating a new array
          newData.push(
            {
              id: 5,
              name: "Last 12 Month Collection",
              fileName: "yearly_data",
              total: formatCurrency(
                data.salesValueData.yearly.reduce((acc, item) => {
                  return item.totalAmount ? acc + item.totalAmount : acc;
                }, 0)
              ),
              data: yearlyData,
            },
            {
              id: 6,
              name: "This Month Collection",
              fileName: "daily_data",
              total: formatCurrency(
                data.salesValueData.daily.reduce((acc, item) => {
                  return item.totalAmount ? acc + item.totalAmount : acc;
                }, 0)
              ),
              data: dailyData,
            },
            {
              id: 7,
              name: "Last 12 Month Order",
              fileName: "yearly_count",
              total:
                yearlyCount.reduce((acc, item) => acc + item.totalCount, 0) ||
                0,
              data: yearlyCount,
            },
            // {
            //   id: 8,
            //   name: "Last 12 Month Furniture",
            //   fileName: "total_furniture_package",
            //   total: totalFurniturePackage,
            //   data: data.salesValueData.furnitureData,
            // },
            {
              id: 9,
              name: "Total Cleaning Package",
              fileName: "total_cleaning_package",
              total: totalCleaningPackage,
              data: data.salesValueData.cleaningData,
            }
          );
        }
        setTenants([...fetchedData, ...newData]);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false); // Hide loader after data is fetched
      }
    };

    fetchData();
  }, []);

  const handleDownload = async (selectedData) => {
    try {
      let xlsxData = selectedData.data;
      console.log("xlsxData", xlsxData);
      // Clean the data before exporting
      xlsxData = xlsxData.map((row, index) => {
        const {
          password,
          is_deleted,
          is_email,
          is_phone_verified,
          lastLoginRole,
          lastLoginTimestamp,
          googleLogin,
          facebookLogin,
          appleLogin,
          status,
          login_attempt_remaining,
          ...cleanedRow
        } = row;

        return { srNumber: index + 1, ...cleanedRow };
      });

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(xlsxData);
      XLSX.utils.book_append_sheet(wb, ws, selectedData.name);

      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const file = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });
      saveAs(file, `${selectedData.fileName}.xlsx`);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardBody>
                <div className="d-flex mb-3">
                  <h3 className="mr-auto">Report</h3>
                </div>

                {/* Show loader while fetching data */}
                {loading ? (
                  <div className="text-center">
                    <Spinner color="primary" />
                  </div>
                ) : (
                  <Row>
                    {tenants &&
                      tenants?.map((tenant) => (
                        <Col
                          lg="4"
                          md="6"
                          sm="6"
                          xl="3"
                          key={tenant.id}
                          className="mb-4"
                        >
                          <Card className="shadow">
                            <CardBody>
                              <CardTitle tag="h5">{tenant.name}</CardTitle>
                              <p>
                                {tenant?.total ? `Total: ${tenant?.total}` : ""}
                              </p>
                              <button
                                className="btn btn-sm btn-primary"
                                onClick={() => handleDownload(tenant)}
                                aria-label="Download XLSX"
                              >
                                <FaDownload />
                              </button>
                            </CardBody>
                          </Card>
                        </Col>
                      ))}
                  </Row>
                )}
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Report;
